import { Link, useNavigate } from "react-router-dom";
import { ROUTES } from "../components/consts/routes.consts";
import { ConnectSpotifyPopup } from "../components/modals/connect-popup";
import { useState } from "react";

export const Footer = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSongSubmit, setIsSongSubmit] = useState(false);
  const [redirectPage, setRedirectPage] = useState("");
  const Id = localStorage.getItem("userId");
  const token = localStorage.getItem("token");
  const isLoggedIn = token && Id;
  // eslint-disable-next-line no-restricted-globals
  const termsAndConditions= location.pathname.includes(ROUTES.TERMS_AND_CONDITIONS)
  const navigate=useNavigate()

  const handleConnect = async () => {
    // window.location.href = "http://localhost:9090/api/auth/login?page=DASHBOARD";
    window.location.href = "https://api.pitchplaylists.com/api/auth/login?page=DASHBOARD";
  };
  return (
    <>
      <footer className="site-footer">
        <div className="footer-blocks">
          <div className="footer-block__logo">
            <a href="/" className="footer-logo__link">
              <img
                src="https://pitchplaylists.com/blog/wp-content/uploads/2025/03/pitchplaylists-logo.png"
                className="footer-logo img-full object-contain"
                alt="Footer Img Logo"
                title="Footer Img Logo"
                width="230"
                height="40"
                loading="lazy"
              />
            </a>
            <p className="footer-text">
              Simple playlist pitching service for artists and curators
            </p>
            {!isLoggedIn && (
              <button
                className="button button--secondary button--with-icon footer-button"
                onClick={handleConnect}
              >
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.5891 0.444806C7.40374 0.122281 0.504868 6.43839 0.180869 14.5526C-0.144486 22.6667 6.2284 29.5043 14.4124 29.8268C22.5978 30.1493 29.4953 23.8332 29.8207 15.719C30.1447 7.60485 23.7732 0.765986 15.5891 0.444806ZM21.8495 21.9841C21.6651 22.3066 21.3059 22.4679 20.9561 22.4195C20.849 22.4047 20.7419 22.3698 20.6416 22.3133C18.6814 21.2073 16.5449 20.487 14.2918 20.1726C12.0387 19.8581 9.78426 19.9669 7.59218 20.4951C7.11635 20.6093 6.63781 20.3204 6.52258 19.8487C6.40735 19.377 6.69881 18.9026 7.17464 18.7884C9.58498 18.2078 12.0631 18.0882 14.5385 18.4336C17.0139 18.779 19.3619 19.5705 21.5187 20.7867C21.943 21.0272 22.0922 21.5621 21.8509 21.9841H21.8495ZM23.7989 18.1245C23.4966 18.6782 22.7971 18.8851 22.2386 18.5855C19.9448 17.3558 17.4613 16.5482 14.8571 16.1853C12.2529 15.8225 9.64192 15.9206 7.09466 16.4756C6.95638 16.5052 6.81946 16.5106 6.68661 16.4917C6.22433 16.4272 5.82849 16.0859 5.72275 15.6061C5.58583 14.9907 5.97896 14.3819 6.59985 14.2462C9.41552 13.632 12.3017 13.5232 15.1784 13.9236C18.0537 14.3241 20.7989 15.2164 23.3339 16.5764C23.8938 16.8761 24.1012 17.5682 23.7989 18.1232V18.1245ZM25.9598 13.7731C25.6751 14.316 25.0827 14.5969 24.5052 14.5163C24.3493 14.4948 24.1961 14.4464 24.0484 14.3711C21.3777 12.9937 18.5011 12.0839 15.4983 11.666C12.4955 11.248 9.47653 11.3367 6.52664 11.9307C5.75935 12.0853 5.01239 11.5934 4.85649 10.8341C4.70059 10.0735 5.19676 9.33304 5.96269 9.1785C9.2298 8.52136 12.5701 8.42326 15.8928 8.88554C19.2155 9.34783 22.3985 10.3557 25.3566 11.881C26.0506 12.2385 26.3204 13.0864 25.9598 13.7745V13.7731Z"
                    fill="white"
                  ></path>
                </svg>
                <span>Connect with Spotify</span>
              </button>
            ) 
            }
          </div>
          <div className="footer-block__menus">
            <div className="footer-block__menu">
              <h3 className="footer-headings">Helpful Links</h3>
              <ul>
                <li className="menu-item">
                  <Link to={ROUTES.SITEMAP}>Sitemap</Link>
                </li>
                <li className="menu-item">
                  <a href={ROUTES.BLOG}>Blog</a>
                </li>
                <li className="menu-item">
                  <Link to={ROUTES.REVIEWS}>Reviews</Link>
                </li>
                <li className="menu-item">
                  <Link to={ROUTES.FAQ}>Faq</Link>
                </li>
              </ul>
            </div>
            <div className="footer-block__menu">
              <h4 className="footer-heading">Get Started</h4>
              <ul>
                {!isLoggedIn ? (
                  <li
                    className="menu-item cursor-pointer text-white"
                    onClick={() => {
                      setIsModalOpen(true);
                      setIsSongSubmit(true);
                      setRedirectPage("SUBMIT-A-SONG")
                    }}
                  >
                    Submit a song
                  </li>
                ) : (
                  <li className="menu-item">
                    <Link to={ROUTES.SUBMIT_A_SONG}>Submit a song</Link>
                  </li>
                )}

                {!isLoggedIn ? (
                  <li
                    className="menu-item cursor-pointer text-white"
                    onClick={() => {
                      setIsModalOpen(true);
                      setIsSongSubmit(false);
                      setRedirectPage("SUBMIT-A-PLAYLIST")
                    }}
                  >
                    Submit a playlist
                  </li>
                ) : (
                  <li className="menu-item">
                    <Link to={ROUTES.SUBMIT_A_PLAYLIST}>Submit a playlist</Link>
                  </li>
                )}

                <li className="menu-item">
                  <Link to={ROUTES.TERMS_AND_CONDITIONS}>
                    Privacy and Terms
                  </Link>
                </li>
                <li className="menu-item">
                  <Link to={ROUTES.CONTACT}>Contact us</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer-block__social">
            <h4 className="footer-heading">Stay Connected</h4>
            <p className="footer-text">
              Follow us on social media to stay updated with the latest news, updates, and exclusive offers! Owned by LLC MUZQ
            </p>
            <div className="social-links">
              <a
                href="https://www.instagram.com/pitchplaylists_/"
                aria-label="Instagram"
                target="_blank"
                className="social-link social-instagram"
              >
             
                <svg xmlns="http://www.w3.org/2000/svg" width="27.021" height="27.032" viewBox="0 0 27.021 27.032">
                  <g id="Group_1" data-name="Group 1" transform="translate(-0.479 -0.391)">
                    <path id="Path_1" data-name="Path 1" d="M14,2.825c3.612,0,4.04.016,5.46.079a7.408,7.408,0,0,1,2.508.465A4.456,4.456,0,0,1,24.527,5.93a7.439,7.439,0,0,1,.465,2.508c.063,1.426.079,1.854.079,5.46s-.016,4.04-.079,5.46a7.409,7.409,0,0,1-.465,2.508,4.456,4.456,0,0,1-2.561,2.561,7.439,7.439,0,0,1-2.508.465c-1.426.063-1.854.079-5.46.079s-4.04-.016-5.46-.079a7.408,7.408,0,0,1-2.508-.465A4.181,4.181,0,0,1,4.476,23.42a4.159,4.159,0,0,1-1.009-1.552A7.439,7.439,0,0,1,3,19.359c-.063-1.426-.079-1.854-.079-5.46S2.94,9.859,3,8.438A7.407,7.407,0,0,1,3.468,5.93,4.181,4.181,0,0,1,4.476,4.378,4.158,4.158,0,0,1,6.029,3.369,7.438,7.438,0,0,1,8.537,2.9C9.958,2.841,10.385,2.825,14,2.825ZM14,.391c-3.67,0-4.129.016-5.571.079A9.878,9.878,0,0,0,5.147,1.1a6.6,6.6,0,0,0-2.4,1.563A6.624,6.624,0,0,0,1.187,5.053,9.906,9.906,0,0,0,.558,8.333C.495,9.78.479,10.239.479,13.909s.016,4.13.079,5.571a9.878,9.878,0,0,0,.628,3.279,6.6,6.6,0,0,0,1.563,2.4,6.609,6.609,0,0,0,2.392,1.558,9.907,9.907,0,0,0,3.279.628c1.442.063,1.9.079,5.571.079s4.13-.016,5.571-.079a9.878,9.878,0,0,0,3.279-.628,6.907,6.907,0,0,0,3.95-3.95,9.907,9.907,0,0,0,.628-3.279c.063-1.442.079-1.9.079-5.571s-.016-4.129-.079-5.571a9.878,9.878,0,0,0-.628-3.279,6.332,6.332,0,0,0-1.547-2.4A6.608,6.608,0,0,0,22.853,1.1,9.906,9.906,0,0,0,19.574.475C18.127.406,17.667.391,14,.391Z" fill="#fff"/>
                    <path id="Path_2" data-name="Path 2" d="M14,2.825c3.612,0,4.04.016,5.46.079a7.408,7.408,0,0,1,2.508.465A4.456,4.456,0,0,1,24.527,5.93a7.439,7.439,0,0,1,.465,2.508c.063,1.426.079,1.854.079,5.46s-.016,4.04-.079,5.46a7.409,7.409,0,0,1-.465,2.508,4.456,4.456,0,0,1-2.561,2.561,7.439,7.439,0,0,1-2.508.465c-1.426.063-1.854.079-5.46.079s-4.04-.016-5.46-.079a7.408,7.408,0,0,1-2.508-.465A4.181,4.181,0,0,1,4.476,23.42a4.159,4.159,0,0,1-1.009-1.552A7.439,7.439,0,0,1,3,19.359c-.063-1.426-.079-1.854-.079-5.46S2.94,9.859,3,8.438A7.407,7.407,0,0,1,3.468,5.93,4.181,4.181,0,0,1,4.476,4.378,4.158,4.158,0,0,1,6.029,3.369,7.438,7.438,0,0,1,8.537,2.9C9.958,2.841,10.385,2.825,14,2.825ZM7.053,13.909A6.944,6.944,0,1,1,14,20.853,6.946,6.946,0,0,1,7.053,13.909Zm14.163-5.6A1.621,1.621,0,1,0,19.595,6.69,1.621,1.621,0,0,0,21.216,8.312Z" fill="#fff" stroke="#fff" strokeWidth="1" fillRule="evenodd"/>
                    <path id="Path_3" data-name="Path 3" d="M14,18.413a4.5,4.5,0,1,1,4.5-4.5A4.505,4.505,0,0,1,14,18.413Z" fill="#fff"/>
                  </g>
                </svg>
              </a>
              <a
                href="https://discord.com/invite/mksG8CJpae"
                target="_blank"
                aria-label="Discord"
                className="social-link social-discord"
              >
                <svg
                  width="31"
                  height="23"
                  viewBox="0 0 31 23"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M25.4253 2.30017C23.4753 1.41517 21.3903 0.770156 19.2303 0.410156C18.9603 0.875156 18.6603 1.50515 18.4503 2.00015C16.1403 1.67015 13.8603 1.67015 11.5803 2.00015C11.3703 1.50515 11.0553 0.875156 10.8003 0.410156C8.62533 0.770156 6.54032 1.41517 4.60532 2.30017C0.675322 8.03017 -0.38968 13.6251 0.15032 19.1451C2.76032 21.0201 5.28033 22.1602 7.75533 22.9102C8.35533 22.1002 8.91031 21.2301 9.37531 20.3151C8.47531 19.9851 7.62032 19.5801 6.81032 19.1001C7.02032 18.9501 7.23033 18.7852 7.42533 18.6202C12.3603 20.8552 17.7303 20.8552 22.6053 18.6202C22.8153 18.7852 23.0103 18.9501 23.2203 19.1001C22.4103 19.5801 21.5553 19.9851 20.6553 20.3151C21.1203 21.2301 21.6753 22.1002 22.2753 22.9102C24.7503 22.1602 27.2853 21.0201 29.8803 19.1451C30.5403 12.7551 28.8453 7.20517 25.4553 2.30017H25.4253ZM10.0203 15.6652C8.5353 15.6652 7.32032 14.3152 7.32032 12.6652C7.32032 11.0152 8.5053 9.66518 10.0203 9.66518C11.5353 9.66518 12.7503 11.0152 12.7203 12.6652C12.7203 14.3152 11.5203 15.6652 10.0203 15.6652ZM19.9803 15.6652C18.4953 15.6652 17.2803 14.3152 17.2803 12.6652C17.2803 11.0152 18.4653 9.66518 19.9803 9.66518C21.4953 9.66518 22.7103 11.0152 22.6803 12.6652C22.6803 14.3152 21.4953 15.6652 19.9803 15.6652Z"
                    fill="white"
                  />
                </svg>
              </a>

              <a
                href="https://www.facebook.com/profile.php?id=61559028706610"
                target="_blank"
                aria-label="Facebook"
                className="social-link social-facebook"
              >
                <svg
                  width="30"
                  height="31"
                  viewBox="0 0 30 31"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M30 15.9102C30 7.62591 23.2843 0.910168 15 0.910168C6.71574 0.910168 0 7.62591 0 15.9102C0 22.9449 4.8429 28.8475 11.3764 30.4684V20.4939H8.28324V15.9102H11.3764V13.935C11.3764 8.8295 13.6868 6.46311 18.6992 6.46311C19.6495 6.46311 21.2893 6.64941 21.9601 6.83577V10.991C21.606 10.9537 20.9911 10.9351 20.2271 10.9351C17.7676 10.9351 16.8172 11.8668 16.8172 14.2891V15.9102H21.7168L20.8751 20.4939H16.8172V30.8003C24.2444 29.9032 30 23.5792 30 15.9102Z"
                    fill="white"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </footer>

      <ConnectSpotifyPopup
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        isSongSubmit={isSongSubmit}
        page={redirectPage}
      />
    </>
  );
};
